import { apiClient } from '@/plugins/axios';

const getCollections = async (filters: Record<string, any> = {}) => {
  const params = new URLSearchParams(filters as any);
  return apiClient.get('/collections?' + params.toString());
};

const getCollectionById = async (id: number) => {
  return apiClient.get(`/collections/${id}`);
};

const createCollection = async (data: any) => {
  return apiClient.post('/collections', data);
};

const updateCollection = async (id: number, data: any) => {
  return apiClient.patch(`/collections/${id}`, data);
};

const deleteCollection = async (id: number) => {
  return apiClient.delete(`/collections/${id}`);
};

export default {
  getCollections,
  getCollectionById,
  createCollection,
  updateCollection,
  deleteCollection,
};
